// Cart badge count (FR-007): the server's item count once the parent cart has loaded (005 FR-032);
// null before then, so no badge shows.
import { useSyncExternalStore } from "react";

import { parentCart } from "@/shop/cartStore";

export function useCartCount(): number | null {
  const state = useSyncExternalStore(
    parentCart.subscribe,
    parentCart.getSnapshot,
    parentCart.getSnapshot,
  );
  return state.cart ? state.cart.itemCount : null;
}
